var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGrayBox = function SvgGrayBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6339 18.0276L31.5377 6.54378C33.3726 5.48541 35.6274 5.48541 37.4623 6.54378L57.3661 18.0276C57.7035 18.2212 57.6545 18.6966 57.3036 18.8644L35.1471 29.4597C34.7379 29.6554 34.2621 29.6554 33.8529 29.4597L11.6964 18.8644C11.3455 18.6966 11.2965 18.2212 11.6339 18.0276Z",
    fill: "#838383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4904 34.2102C36.4904 33.6325 36.8221 33.1062 37.3432 32.857L59.7543 22.1394C59.9949 22.0243 60.2803 22.1632 60.318 22.4273C60.3556 22.702 60.375 22.9807 60.375 23.2619V46.0831C60.375 48.247 59.2269 50.2447 57.3661 51.3174L37.4623 62.8013C37.0096 63.0619 36.4904 62.7004 36.4904 62.1781V34.2102Z",
    fill: "#838383"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6568 32.857C32.1779 33.1062 32.5096 33.6325 32.5096 34.2102V62.1781C32.5096 62.7004 31.9904 63.0619 31.5377 62.8013L11.6339 51.3174C9.7731 50.2447 8.625 48.247 8.625 46.0831V23.2619C8.625 23.227 8.6253 23.1921 8.6259 23.1573C8.63691 22.5153 9.3273 22.1784 9.90657 22.4554L31.6568 32.857Z",
    fill: "#838383"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrayBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GrayBox.83f530f8.svg";
export { ForwardRef as ReactComponent };